import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-screen flex-col justify-center bg-gray-50 py-8 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "mt-8 sm:mx-auto sm:w-full sm:max-w-md" }
const _hoisted_5 = { class: "bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10" }
const _hoisted_6 = { class: "rounded-md bg-red-50 p-4" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "shrink-0" }
const _hoisted_9 = { class: "ml-3" }
const _hoisted_10 = { class: "text-sm font-medium text-red-800" }
const _hoisted_11 = { class: "rounded-md bg-yellow-100 p-4" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "shrink-0" }
const _hoisted_14 = { class: "ml-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-medium text-yellow-800" }, "Der Benutzer existiert bereits", -1)
const _hoisted_16 = { class: "mt-2 text-sm text-yellow-700" }
const _hoisted_17 = { class: "text-center text-sm" }
const _hoisted_18 = { href: "https://www.oculai.de/agb" }
const _hoisted_19 = { class: "text-yellow-800 font-medium" }
const _hoisted_20 = { class: "pt-4 flex items-center justify-center" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "flex items-center gap-3 text-sm text-gray-400 my-6" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "border-t flex-1" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "border-t flex-1" }, null, -1)
const _hoisted_27 = {
  key: 0,
  class: "rounded-md bg-red-50 p-4 mb-6"
}
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = { class: "shrink-0" }
const _hoisted_30 = { class: "ml-3" }
const _hoisted_31 = { class: "text-sm font-medium text-red-800" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  alt: "microsoft logo",
  src: "data:image/svg+xml,%3csvg%20width='21'%20height='21'%20viewBox='0%200%2021%2021'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='11.375'%20y='11.375'%20width='8.75'%20height='8.75'%20fill='%23FEBA08'/%3e%3crect%20x='0.875'%20y='11.375'%20width='8.75'%20height='8.75'%20fill='%2305A6F0'/%3e%3crect%20x='11.375'%20y='0.875'%20width='8.75'%20height='8.75'%20fill='%2380BC06'/%3e%3crect%20x='0.875'%20y='0.875'%20width='8.75'%20height='8.75'%20fill='%23F25325'/%3e%3c/svg%3e"
}, null, -1)
const _hoisted_33 = { class: "pt-4 text-center text-sm text-yellow-900" }

import { XCircleIcon, ExclamationTriangleIcon } from "@heroicons/vue/24/solid";
import { Auth } from "aws-amplify";
import { Form, SubmissionHandler } from "vee-validate";
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import * as yup from "yup";
import logoMultipleNoPaddingSrc from "shared/assets/imgs/logo/logo-multiple-no-padding.svg";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import { userRoles } from "shared/constants/user";
import logger from "shared/services/logger";
import InputField from "@/components/forms/InputField.vue";
import PasswordField from "@/components/forms/PasswordField.vue";
import SelectListField from "@/components/forms/SelectListField.vue";
import { useMicrosoftSignIn, useLoadUserData } from "@/composables/auth";
import UserRepository from "@/repositories/UserRepository";
import Footer from "@/views/auth/components/Footer.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUp',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { t } = useI18n();

const microsoftSignIn = useMicrosoftSignIn();
const loadUserData = useLoadUserData();

const roleTypes = userRoles.map((role) => ({
  value: role,
  name: t(`admin.project_participants.user_roles.${role}`),
}));

const errorMessageInvalidInput = ref("");
const userExistsAlert = ref(false);
const invalidInputAlert = ref(false);
const isLoading = ref(false);
const socialAlert = ref(false);

const initialValues = computed(() => ({
  email: (route.query.email as string) || "",
  firstName: "",
  lastName: "",
  company: "",
  role: "",
  passwordTemporary: atob((route.query.code as string) || ""),
  password1: "",
  password2: "",
}));

const signUpSchema = yup.object().shape({
  email: yup
    .string()
    .email(t("authentication.validation.validation_email_invalid"))
    .required(t("authentication.validation.validation_field_required")),
  firstName: yup.string().required(t("authentication.validation.validation_field_required")),
  lastName: yup.string().required(t("authentication.validation.validation_field_required")),
  company: yup.string().required(t("authentication.validation.validation_field_required")),
  role: yup.string().required(t("authentication.validation.validation_field_required")),
  passwordTemporary: yup
    .string()
    .required(t("authentication.validation.validation_field_required")),
  password1: yup
    .string()
    .min(10, t("authentication.validation.validation_password_characters"))
    .required(t("authentication.validation.validation_field_required")),
  password2: yup
    .string()
    .oneOf([yup.ref("password1")], t("authentication.validation.validation_password_not_equal"))
    .required(t("authentication.validation.validation_field_required")),
});

const showEmailAndCodeField = computed(() => {
  return !(route.query.email as string) || !(route.query.code as string);
});

const getCleanedName = (name: string) => {
  // Remove whitespaces and special characters.
  return name.trim().replace(/[&/\\#,+()$~%.'":*?<>{}]/g, "");
};

const handleSubmitSignUp: SubmissionHandler = async (genericObject) => {
  isLoading.value = true;
  invalidInputAlert.value = false;
  userExistsAlert.value = false;

  try {
    const { email, firstName, lastName, company, passwordTemporary, password1, role } =
      genericObject;
    const name = `${getCleanedName(firstName)} ${getCleanedName(lastName)}`;

    const user = await Auth.signIn(email, passwordTemporary);

    const requiredAttributes = {
      name: name,
      "custom:company": company,
    };

    if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
      try {
        await Auth.completeNewPassword(user, password1, requiredAttributes);
        await UserRepository.completeSignUp(email, name, company, role);
        router.push("/log-in");
      } catch (e) {
        const error = e as Error;
        handleSignUpError(error);
      }
    } else {
      userExistsAlert.value = true;
    }
  } catch (e) {
    const error = e as Error;
    if (error.message === "Incorrect username or password.") {
      errorMessageInvalidInput.value = t("authentication.sign_up.error_mail_password");
      invalidInputAlert.value = true;
    } else {
      logger.error("Unable to sign up", error);
      invalidInputAlert.value = true;
    }
  } finally {
    isLoading.value = false;
  }
};

const handleSignUpError = (e: Error) => {
  switch (e.message) {
    case "Username should be either an email or a phone number.":
      errorMessageInvalidInput.value = t("authentication.sign_up.error_must_be_mail");
      break;
    case "User is not confirmed.":
      errorMessageInvalidInput.value = t("authentication.sign_up.error_user_not_confirmed");
      break;
    case "Incorrect username or password.":
      errorMessageInvalidInput.value = t("authentication.sign_up.error_mail_password");
      break;
    case "User does not exist.":
      errorMessageInvalidInput.value = t("authentication.sign_up.error_user_not_existing");
      break;
    default:
      errorMessageInvalidInput.value = t("authentication.sign_up.error_unknown");
  }
  invalidInputAlert.value = true;
};

const triggerMicrosoftLogin = async () => {
  isLoading.value = true;
  errorMessageInvalidInput.value = "";
  userExistsAlert.value = false;
  invalidInputAlert.value = false;
  socialAlert.value = false;

  try {
    const name = await microsoftSignIn(route.query.email as string);
    await UserRepository.completeSignUp(route.query.email as string, name, null, null, "sso");
    await loadUserData();
    router.push("/");
  } catch (e) {
    const error = e as Error;
    if (
      error?.message !== "Different email in logged in account" &&
      error?.message !== "No current user" &&
      error?.message !== "user_cancelled: User cancelled the flow." &&
      !error?.message.includes("interaction_in_progress")
    ) {
      logger.error(error);
    }
    socialAlert.value = true;
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "mx-auto h-12 w-auto",
        src: _unref(logoMultipleNoPaddingSrc),
        alt: "Workflow"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(Form), {
          onSubmit: handleSubmitSignUp,
          initialValues: initialValues.value,
          validationSchema: _unref(signUpSchema),
          class: "flex flex-col gap-2 w-full"
        }, {
          default: _withCtx(() => [
            (showEmailAndCodeField.value)
              ? (_openBlock(), _createBlock(InputField, {
                  key: 0,
                  name: "email",
                  label: _ctx.$t('authentication.sign_up.email')
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(InputField, {
              name: "firstName",
              label: _ctx.$t('authentication.sign_up.first_name')
            }, null, 8, ["label"]),
            _createVNode(InputField, {
              name: "lastName",
              label: _ctx.$t('authentication.sign_up.last_name')
            }, null, 8, ["label"]),
            _createVNode(InputField, {
              name: "company",
              label: _ctx.$t('authentication.sign_up.company')
            }, null, 8, ["label"]),
            _createVNode(SelectListField, {
              name: "role",
              label: _ctx.$t('authentication.sign_up.your_role'),
              options: _unref(roleTypes),
              minWidth: 250,
              placeholder: `--
              ${_ctx.$t('form.select_option')} --`
            }, null, 8, ["label", "options", "placeholder"]),
            (showEmailAndCodeField.value)
              ? (_openBlock(), _createBlock(PasswordField, {
                  key: 1,
                  name: "passwordTemporary",
                  label: _ctx.$t('authentication.sign_up.temporary_password')
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(PasswordField, {
              name: "password1",
              label: _ctx.$t('authentication.sign_up.new_password')
            }, null, 8, ["label"]),
            _createVNode(PasswordField, {
              name: "password2",
              label: _ctx.$t('authentication.sign_up.repeat_new_password')
            }, null, 8, ["label"]),
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(XCircleIcon), {
                    class: "h-5 w-5 text-red-400",
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h3", _hoisted_10, _toDisplayString(errorMessageInvalidInput.value), 1)
                ])
              ])
            ], 512), [
              [_vShow, invalidInputAlert.value]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(ExclamationTriangleIcon), {
                    class: "h-5 w-5 text-yellow-400",
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("p", null, [
                      _createTextVNode(" Bitte logge dich über die "),
                      _createElementVNode("u", null, [
                        _createVNode(_component_router_link, { to: "/log-in" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Login-Seite")
                          ]),
                          _: 1
                        })
                      ]),
                      _createTextVNode(" ein. ")
                    ])
                  ])
                ])
              ])
            ], 512), [
              [_vShow, userExistsAlert.value]
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createTextVNode(_toDisplayString(_ctx.$t("authentication.sign_up.terms_conditions_1")) + " ", 1),
              _createElementVNode("a", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("authentication.sign_up.terms_conditions_2")), 1)
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("authentication.sign_up.terms_conditions_3")), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                type: "submit",
                disabled: isLoading.value,
                class: "focus:outline-none inline-flex justify-center rounded-md border border-transparent bg-yellow-600 px-20 py-2 text-base font-medium text-white shadow-sm hover:bg-yellow-600 focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
              }, [
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      (isLoading.value)
                        ? (_openBlock(), _createBlock(LoadingSpinner, {
                            key: 0,
                            size: "w-5 h-5",
                            color: "white"
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, "Sign Up"))
              ], 8, _hoisted_21)
            ])
          ]),
          _: 1
        }, 8, ["initialValues", "validationSchema"]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("authentication.login.or")) + " ", 1),
          _hoisted_26
        ]),
        (socialAlert.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_unref(XCircleIcon), {
                    class: "h-5 w-5 text-red-400",
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.$t("authentication.sign_up.social_error")), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "border px-5 py-2 rounded-lg flex gap-3 w-full justify-center mb-6",
          type: "button",
          style: {"font-family":"Montserrat-SemiBold, system-ui"},
          onClick: triggerMicrosoftLogin
        }, [
          _hoisted_32,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("authentication.sign_up.sign_up_with_microsoft")), 1)
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_router_link, {
            to: "/log-in",
            class: "font-sm hover:text-yellow-700"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("authentication.sign_up.already_registered")), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(Footer)
  ]))
}
}

})